// Pure keyword-matching chatbot — no API needed

const KB = [
  {
    tags: ["hello","hi","hey","good morning","good afternoon","good evening","kumusta","musta","kamusta","magandang"],
    answer: "Hi! I'm Goldie, the Golden Gateway assistant. Ask me about our application process, requirements, qualifications, fees, or jobs. How can I help?"
  },

  // === APPLICATION PROCESS ===
  {
    tags: ["step","process","how to apply","paano","procedure","flow","apply","mag-apply","application","proseso","steps","how","request endorsement"],
    answer: "7-Step process:\n1️⃣ Submit requirements at our office\n2️⃣ Medical exam (healthy & fit required)\n3️⃣ Family briefing\n4️⃣ Interview\n5️⃣ Free Japan Language School (4–5 months, no allowance, free tuition)\n6️⃣ Final medical & compliance\n7️⃣ Deployment to Japan (ticket cost covered by the employer)\n\nClick \"Request Endorsement\" on our homepage to get started — you'll select your job package, see this process, and submit everything in one go."
  },
  {
    tags: ["timeline","phase 1","phase 2","phase","endorsement phase","internship phase","stages"],
    answer: "Two phases:\n📋 Phase 1 — Endorsement: Submit requirements → Pay endorsement fee → Receive endorsement documents → Submit to agency for slot.\n📋 Phase 2 — Business Documents: After Phase 1 claimed, request Company Profile & Brochure for internship/visa. Contact your endorser for Phase 2 details.\n✈ For Aboard: Final clearance after all phases are complete."
  },

  // === REQUIREMENTS ===
  {
    tags: ["requirement","document","bring","need","requirements","list","ano","dala","papeles","file","what to bring","complete"],
    answer: "View the complete list of requirements on our Requirements page (see the navigation menu), or click 'View Requirements' on any job card on the homepage.\n\nYou must submit complete requirements at our office for screening. Incomplete requirements cannot proceed."
  },
  {
    tags: ["complete requirement","incomplete","requirements complete","need to complete","all requirements"],
    answer: "You need to complete ALL requirements for screening. Incomplete submissions cannot proceed to the next step. Submit at our office at Don Gil Garcia Street, Capitol Site, Cebu City."
  },

  // === QUALIFICATIONS ===
  {
    tags: ["qualify","qualification","who can","eligible","pwede","edad","age","male","graduate","can i apply","am i qualified"],
    answer: "Basic qualifications:\n✅ Junior/Senior High School or ALS graduate\n✅ Male, 20–30 years old\n✅ No visible or erased tattoo\n✅ Willing to work in Japan\n✅ Good attitude\n\nNote: Exact age and other qualifications depend on the specific job and employer — check the job listings on our homepage."
  },
  {
    tags: ["tattoo","balat","mark","may tattoo","tattoo allowed"],
    answer: "Tattoo eligibility depends on the specific job and employer. Check the requirements listed under each job hiring on our homepage. Some employers do not allow any visible or erased tattoos."
  },

  // === MEDICAL ===
  {
    tags: ["medical","check-up","checkup","health","medico","health exam","medical exam","fit","healthy"],
    answer: "Step 2 is a medical exam. You must be healthy and fit to pass. The agency will instruct you after submitting your requirements."
  },

  // === SCHOOLING ===
  {
    tags: ["language","schooling","japanese","nihongo","school","training","free training","tuition","month","allowance","libre school"],
    answer: "Japan Language Schooling (Step 5):\n✅ FREE tuition — completely free\n❌ No allowance provided\n❌ Personal expenses NOT covered\n⏱ Duration: 3–4 months\n\nOnly tuition is covered. You must prepare for your own living expenses during school."
  },
  {
    tags: ["duration","how long school","ilang buwan","school duration","3 month","4 month"],
    answer: "Japan Language School duration is 3–4 months. No allowance, free tuition only."
  },

  // === DEPLOYMENT / FLIGHT ===
  {
    tags: ["flight","ticket","plane","deploy","deployment","booking","alis","byahe","libre ticket","free ticket","book"],
    answer: "Once you are cleared and ready for boarding, the agency provides a FREE booking ticket for your flight to Japan. No need to pay for the ticket."
  },

  // === ENDORSEMENT ===
  {
    tags: ["endorsement","letter","endorse","endorsement letter","where get","where to get endorsement","get endorsement","punta saan"],
    answer: "Contact your Endorser to get your Endorsement Letter and other documents. Your endorser is Golden Gateway International Agency.\n\nYou cannot proceed to the agency without an Endorsement Letter."
  },
  {
    tags: ["endorsement expiration","expire","expired","valid","how long valid","matagal ba","expiry"],
    answer: "There is NO expiration for endorsement documents. Your endorsement remains valid."
  },
  {
    tags: ["without endorsement","no endorsement","need endorsement","wala endorsement","bakit kailangan"],
    answer: "You CANNOT proceed to the agency without an Endorsement Letter. It is a required document for the Japan application process."
  },
  {
    tags: ["where submit","isubmit saan","submit documents","submit requirements","where to go","don gil","address","office location","location","saan"],
    answer: "Submit your documents at:\n📍 Golden Gateway International Agency\nDon Gil Garcia Street, Capitol Site, Cebu City\n📞 0916-703-9459 / 0962-526-1239\n\nOffice hours: Working days. Walk-in is welcome."
  },

  // === FEES ===
  {
    tags: ["fee","cost","bayad","6000","6,000","magkano","price","piso","php","payment","how much","charge","phase 1 fee","endorsement fee"],
    answer: "Phase 1 (Endorsement): ₱6,000 to process your Endorsement Letter and Documents, collected in cash when you receive them.\n\nFor Phase 2 (Business Documents & Company Profile): ₱6,000, also collected in cash when you receive those documents.\n\n📞 0916-703-9459 / 0962-526-1239"
  },
  {
    tags: ["placement fee","show money","pera","placement","show","money"],
    answer: "NO placement fee. NO show money required. Golden Gateway does not collect placement fees or require show money."
  },
  {
    tags: ["phase 2 fee","business document fee","company profile fee","brochure fee"],
    answer: "Phase 2 fee (Business Documents & Company Profile): ₱6,000, collected in cash when you receive the documents.\n📞 0916-703-9459 / 0962-526-1239"
  },

  // === PAYMENT ===
  {
    tags: ["gcash","cash","bayad","payment method","how to pay","magbabayad","pay first","pay before","pay upon pickup","pay upon receipt"],
    answer: "💵 Payment is collected in cash only, when you receive your endorsement documents. No GCash, and no need to pay before processing — you don't pay anything in advance."
  },
  {
    tags: ["pay before","pay in advance","can i pay first","bayad muna","advance payment"],
    answer: "No. You pay in cash only when you receive your documents at our office. You do not need to pay in advance, and we no longer accept GCash."
  },

  // === RE-ENDORSEMENT ===
  {
    tags: ["re-endorse","re endorse","renew endorsement","renew","bundle","free re-endorse","laundry baker food"],
    answer: "Re-endorsement is FREE if your jobs are in the bundle (Laundry, Baker, FoodPro, Agricultural Farming). These 4 are bundled together — re-endorsing any of them is already included in your original payment."
  },

  // === JOBS ===
  {
    tags: ["job","work","position","laundry","baker","baking","food","meat","foodpro","farm","farming","agriculture","agricultural","available job","anong trabaho","linen","bundle job"],
    answer: "Available bundled positions:\n🧺 Laundry/Linen Worker\n🍞 Baker/Pastry Worker\n🥩 Food Processing/Meat Processing Worker\n🌾 Agricultural Farm Worker\n\nThese 4 are bundled — selecting one includes all four. Check our homepage for job details, requirements, and current openings."
  },
  {
    tags: ["switch job","change job","palitan","other job","switch hiring","change hiring"],
    answer: "Switching to a different hiring is generally NOT allowed once you are in process and near the lineup. If you have concerns, contact the agency directly.\n📞 0916-703-9459 / 0962-526-1239"
  },
  {
    tags: ["other job","caregiver","construction","hotel","farm","factory","other position"],
    answer: "For other job positions (Caregiver, Construction, Hotel, etc.), contact our office for current availability.\n📞 0916-703-9459 / 0962-526-1239"
  },

  // === COUPLES ===
  {
    tags: ["couple","mag-asawa","husband","wife","asawa","same employer","both apply","2 person"],
    answer: "Couples applying to the SAME employer through the SAME agency are generally NOT allowed. Most employers and agencies discourage this. Some exceptions exist, but the majority do not allow it. It's best to apply separately or check with the agency."
  },

  // === LINEUP ===
  {
    tags: ["lineup","line up","how long wait","waiting","queue","pila","ilang taon","ilang buwan wait","how long"],
    answer: "Lineup duration varies. Please contact the agency or stay updated through the agency's Messenger group chat (GC) for lineup and hiring vacancy updates.\n📞 0916-703-9459 / 0962-526-1239"
  },

  // === OFFICE ===
  {
    tags: ["office","address","location","saan opisina","where office","where agency","contact","phone","number","call","reach","hotline","open","office hour","time","working"],
    answer: "Office:\n📍 Don Gil Garcia Street, Capitol Site, Cebu City\n📞 0916-703-9459 / 0962-526-1239\n🕐 Open on working days — walk-in welcome.\n\nFor office hours and availability, visit the agency page or call directly."
  },

  // === CAV ===
  {
    tags: ["cav","certificate","authentication","verification","deped","ched","school","diploma","tor","transcript"],
    answer: "For CAV processing:\n🏫 High School graduates → Go to your school, get the required documents, then process through DepEd.\n🎓 College graduates → Go to your school, get required documents, then process through CHED.\n\nFor more details, visit your school's registrar office."
  },

  // === MEDICAL / FITNESS ===
  {
    tags: ["healthy","fit","medical requirement","pass medical","physical","dapat malusog"],
    answer: "Medical requirement: You must be HEALTHY and FIT to pass the medical exam (Step 2). Any medical conditions that affect fitness for work may disqualify you. The agency will provide details on the specific medical requirements."
  },

  // === INTERVIEW ===
  {
    tags: ["interview","interbyu","scheduled","pass","fail interview"],
    answer: "Step 4 is the Interview. Attend the scheduled interview at our office. If you pass, you proceed to Japan Language Schooling. If you do not pass, contact the agency for guidance."
  },

  // === FAMILY BRIEFING ===
  {
    tags: ["briefing","orientation","family","parents","spouse","seminar"],
    answer: "Step 3 is a Family Briefing — a short orientation for parents or spouse. This is required before proceeding to the interview stage."
  },

  // === GCHAT / MESSENGER ===
  {
    tags: ["messenger","gc","group chat","facebook","fb","update","notify","announcement"],
    answer: "Join the agency's Messenger Group Chat (GC) to stay updated on hiring vacancies, lineups, and announcements. Contact our office to be added.\n📞 0916-703-9459 / 0962-526-1239"
  },

  // === TRACKING ===
  {
    tags: ["track","tracking","application id","endorsement id","status","check status","where check","how track"],
    answer: "Track your request anytime using your Endorsement ID on our website's 'Track Endorsement' page. Save this ID — you'll need it to track your document status request."
  },

  // === FREE / LIBRE ===
  {
    tags: ["free","libre","no payment","walang bayad","what is free"],
    answer: "FREE from Golden Gateway:\n✅ Japan Language School tuition (3–4 months)\n✅ Flight ticket when cleared for boarding\n✅ Re-endorsement for bundled jobs (Laundry, Baker, FoodPro)\n\nNot free: Personal expenses during school, endorsement processing fee."
  },

  // === FAREWELL ===
  {
    tags: ["thank","thanks","salamat","okay","ok","sige","noted","gets","bye","goodbye","paalam"],
    answer: "You're welcome! If you have more questions, feel free to ask. Good luck with your application! 🙏"
  }
];

const FALLBACK = "I don't have specific information about that yet. Please contact our office directly:\n📞 0916-703-9459 / 0962-526-1239\n📍 Don Gil Garcia Street, Capitol Site, Cebu City\n\nWorking days — walk-in welcome.";

function normalize(text) {
  return text.toLowerCase().replace(/[^a-z0-9\s]/g, " ").trim();
}

export function getBotReply(question) {
  const q = normalize(question);

  let bestScore = 0;
  let bestAnswer = FALLBACK;

  for (const entry of KB) {
    let score = 0;
    for (const tag of entry.tags) {
      if (q.includes(tag)) {
        score += tag.split(" ").length > 1 ? 3 : 1;
      }
    }
    if (score > bestScore) {
      bestScore = score;
      bestAnswer = entry.answer;
    }
  }

  return bestAnswer;
}
